module.exports = __webpack_public_path__ + "img/banner-bckg.43816526.png";